import React, { FC } from 'react';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './RoundedRectangularMediumBanner.module.scss';

export interface MediumBannerProps {
  imageUrl: string;
  imageUrlMobile: string;
  referenceLabel: string;
  referenceUrl: string;
  label?: string;
  priceFormatted?: string;
}

const RoundedRectangularMediumBanner: FC<MediumBannerProps> = ({
  imageUrl,
  imageUrlMobile,
  referenceUrl,
  referenceLabel,
}) => {
  const { isDesktopDevice } = useLandingPageContext();

  return (
    <div className={styles.container}>
      <a href={referenceUrl} className={styles.rectangularBanner}>
        <img src={isDesktopDevice ? imageUrl : imageUrlMobile} alt="" />
      </a>
      {referenceLabel && (
        <a href={referenceUrl} className={styles.label}>
          {referenceLabel}
        </a>
      )}
    </div>
  );
};

export default RoundedRectangularMediumBanner;
